// extracted by mini-css-extract-plugin
var _1 = "host-offset-scope__FJ9j7";
var _2 = "module__pGnjc";
var _3 = "no-access___wKr5";
var _4 = "page__Q8kzH";
export { _1 as "hostOffsetScope", _2 as "module", _3 as "noAccess", _4 as "page" }
